'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [],
        _n = !0,
        _d = !1,
        _e = void 0;

    try {
      for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i['return'] && _i['return']();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) return arr;
    if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
  };
}(),
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _FormContext = require('../context/FormContext'),
    _FormContext2 = _interopRequireDefault(_FormContext),
    _propTypes3 = require('../propTypes'),
    _styles = require('../styles'),
    _themes = require('../themes'),
    _utils = require('../utils');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  form: _styledComponents2.default.form.withConfig({
    displayName: 'Form__form'
  })(['', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;'], function (props) {
    return props.inheritStyles ? '' : _styles.resetInheritedStyles;
  }, function (props) {
    return props.theme.vstui.color.onSurface;
  }, function (props) {
    return props.theme.vstui.typography.fontFamily;
  }, function (props) {
    return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize);
  }, function (props) {
    return props.theme.vstui.typography.fontWeightRegular;
  })
},
    Form = function (_Component) {
  function Form() {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));

    return _this.isReadyToSubmit = !1, _this.isValidating = !1, _this.registeredFormControls = {}, _this.handleFormRef = _this.handleFormRef.bind(_this), _this.handleSubmit = _this.handleSubmit.bind(_this), _this.registerFormControl = _this.registerFormControl.bind(_this), _this;
  }

  return _inherits(Form, _Component), _createClass(Form, [{
    key: 'reset',
    value: function reset() {
      this.resetForm();
    }
  }, {
    key: 'validate',
    value: function validate(callback) {
      this.validateForm(function (valid) {
        callback && callback(valid);
      });
    }
  }, {
    key: 'registerFormControl',
    value: function registerFormControl(_ref) {
      var focus = _ref.focus,
          id = _ref.id,
          reset = _ref.reset,
          validate = _ref.validate;
      this.registeredFormControls[id] = {
        focus: focus,
        reset: reset,
        validate: validate
      };
    }
  }, {
    key: 'handleFormRef',
    value: function handleFormRef(node) {
      var innerRef = this.props.innerRef;
      node && (this.nativeForm = node), innerRef && innerRef(node);
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      var _this2 = this,
          onReset = this.props.onReset;

      this.nativeForm.reset();
      var resetFormControls = new Promise(function (resolve) {
        Object.values(_this2.registeredFormControls).forEach(function (_ref2, i) {
          var reset = _ref2.reset;
          reset(), i === Object.keys(_this2.registeredFormControls).length - 1 && resolve();
        });
      });
      resetFormControls.then(function () {
        onReset && onReset();
      });
    }
  }, {
    key: 'validateForm',
    value: function validateForm(callback) {
      var _this3 = this,
          onValidate = this.props.onValidate,
          focusFirstInvalidFormControl = void 0,
          validationMessages = {},
          validateFormControls = new Promise(function (resolve) {
        (0, _utils.entries)(_this3.registeredFormControls).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              validate = _ref4[1].validate;

          validate(function (valid, validationMessage) {
            validationMessages[key] = validationMessage, Object.keys(validationMessages).length === Object.keys(_this3.registeredFormControls).length && resolve();
          });
        });
      });

      validateFormControls.then(function () {
        (0, _utils.entries)(_this3.registeredFormControls).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              focus = _ref6[1].focus;

          !focusFirstInvalidFormControl && validationMessages[key] && (focusFirstInvalidFormControl = focus);
        }), focusFirstInvalidFormControl ? (focusFirstInvalidFormControl(), onValidate && onValidate(!1), callback && callback(!1)) : (onValidate && onValidate(!0), callback && callback(!0));
      });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      var _this4 = this,
          onSubmit = this.props.onSubmit;

      return this.isValidating ? void event.preventDefault() : void (this.isReadyToSubmit ? (onSubmit && onSubmit(event), !event.isTrusted && !event.defaultPrevented && this.nativeForm.submit(), this.isReadyToSubmit = !1) : (event.preventDefault(), this.isValidating = !0, this.validateForm(function (valid) {
        _this4.isValidating = !1, _this4.isReadyToSubmit = valid, valid && _this4.dispatchSubmitEvent();
      })));
    }
  }, {
    key: 'dispatchSubmitEvent',
    value: function dispatchSubmitEvent() {
      var _this5 = this,
          submitEvent = (0, _utils.createEvent)('submit', {
        bubbles: !0,
        cancelable: !0
      });

      setTimeout(function () {
        _this5.nativeForm.dispatchEvent(submitEvent);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_FormContext2.default.Provider, {
        value: this.registerFormControl
      }, _react2.default.createElement(Styled.form, _extends({}, this.props, {
        innerRef: this.handleFormRef,
        noValidate: !0,
        onSubmit: this.handleSubmit
      })));
    }
  }]), Form;
}(_react.Component);

Form.propTypes = {
  innerRef: _propTypes2.default.func,
  onReset: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  onValidate: _propTypes2.default.func,
  theme: _propTypes3.themeShape
}, Form.defaultProps = {
  theme: (0, _themes.createTheme)()
}, Form.displayName = 'Form';
var FormWithTheme = (0, _themes.withTheme)(Form);
FormWithTheme.WrappedComponent = Form, exports.default = FormWithTheme;